import { ReApi, ReApiVersion } from '@/composables/query'
import axios from '@/plugins/axios'

function getWorkload() {
  return axios.get(`/api/${ReApi.VALUATION}/${ReApiVersion.CURRENT}/workload`)
}

export { getWorkload }
